export default __webpack_public_path__ + "static/media/profile.b552d7c1.jpg";